import { Grid, Segment } from '@mairistem/composants';
import React from 'react';
import './ElaborationBudgetPlaceholder.css';

const ElaborationBudgetPlaceholder = () => (
	<Segment basic secondary>
		<Grid stretched>
			<Grid.Row className="elaborationBudgetLoadingOutils">
				<Grid.Column width={4}>
					<Segment loading />
				</Grid.Column>
				<Grid.Column width={12}>
					<Segment loading />
				</Grid.Column>
			</Grid.Row>
		</Grid>
		<Segment className="elaborationBudgetLoadingIndicateurs" loading />
		<Segment className="elaborationBudgetLoadingTreeView" loading />
	</Segment>
);

export default ElaborationBudgetPlaceholder;
